export enum OrderIntent {
  BUY,
  SELL,
}

export namespace OrderIntent {
  let elements = [OrderIntent.BUY, OrderIntent.SELL];
  let alias = "com.bcdfx.model.OrderIntent";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
